<template>
    <a-modal
        :maskClosable="false"
            title="会员优惠配置"
            :width="1000"
            :style="{'top':'10px'}"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="visibleModel"
            @cancel="handleCancel"
            @ok="handleOk"
    >
        <a-spin :spinning="saveLoading">
            <a-form :form="form">

                <a-form-item
                        label="是否开启会员功能"
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                >
                    <r-switch :formData="formData" field="open_member_discount" :checkedValue="1" :unCheckedValue="2"
                              checkedChildren="开启" unCheckedChildren="关闭"/>
                </a-form-item>

                <a-form-item
                        v-show="formData.open_member_discount==1"
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                        label="规则配置"
                        hasFeedback
                >
                    <a-radio-group v-model="formData.member_discount_setting_mode" buttonStyle="solid">
                        <a-radio-button :value="1">以全局配置为准</a-radio-button>
                        <a-radio-button :value="2">以商品分类配置为准</a-radio-button>
                        <a-radio-button :value="3">该商品单独配置</a-radio-button>
                    </a-radio-group>
                </a-form-item>


                <div v-show="formData.member_discount_setting_mode==3">

                    <!--          <a-form-item-->
                    <!--                  v-show="formData.open_member_discount==1"-->
                    <!--                  :labelCol="labelCol"-->
                    <!--                  :wrapperCol="wrapperCol"-->
                    <!--                  label="奖励模式"-->
                    <!--                  hasFeedback-->
                    <!--          >-->
                    <!--            <a-radio-group v-model="formData.seller_reward_mode" buttonStyle="solid">-->
                    <!--              <a-radio-button :value="1">统一设置</a-radio-button>-->
                    <!--              <a-radio-button :value="2">按用户组设置</a-radio-button>-->
                    <!--            </a-radio-group>-->

<!--                              </a-form-item>-->

                    <a-form-item
                            v-show="formData.open_member_discount==1"
                            :labelCol="labelCol"
                            :wrapperCol="wrapperCol"
                            label="商品模式"
                            hasFeedback
                    >
                        <a-radio-group v-model="formData.member_discount_goods_mode" buttonStyle="solid">
                            <a-radio-button :value="1">按商品整体配置</a-radio-button>
                            <a-radio-button :value="2">按每个sku配置</a-radio-button>
                        </a-radio-group>

                        <a-select
                                v-if="formData.member_discount_mode==2&&formData.member_discount_goods_mode==2"
                                placeholder="请先配置会员特权卡"
                                v-model="sellerGroupSelectValue"
                                style="width: 200px; margin-left: 10px;" >
                            <a-select-option :value="option.id" :key="option.id" v-for="option in formData.memberDiscountList">{{option.name}}</a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-table
                            v-show="formData.open_member_discount==1&& formData.member_discount_mode==2 && formData.member_discount_goods_mode==1"
                            :columns="sellerGroupColumns" :dataSource="formData.memberDiscountList"
                            :locale="{emptyText:'请先配置会员特权卡'}" :pagination="false" rowKey="id" bordered>
                        <template slot="sellerPercent" slot-scope="text,record">
                            <a-radio-group v-model="record.member_discount_type" buttonStyle="solid">
                                <a-radio :value="'discount'">按折扣优惠</a-radio>
                                <a-radio :value="'reduce'">按金额优惠</a-radio>
                            </a-radio-group>
                            <!--            <a-input type="number"  v-model="record.seller_percent" placeholder="千分之几"/>-->
                        </template>
                        <template slot="teamPercent" slot-scope="text,record">
                            <PriceInput
                                    v-if="record.member_discount_type == 'discount'"
                                    :formData="record"
                                    field="member_discount_value"
                                    placeholder="范围为0~9.9"/>
                            <!--                        <a-input type="number" v-model="record.member_discount_value" placeholder="请输入优惠金额"/>-->
                            <PriceInput :formData="record"
                                        v-else
                                        field="member_discount_value"
                                        placeholder="请输入优惠金额"/>
<!--                            <a-input type="number" v-model="record.member_discount_value"-->
<!--                                     v-if="record.member_discount_type == 'discount'" placeholder="范围为1~99（十分之几）"/>-->
<!--                            <a-input type="number" v-model="record.member_discount_value" v-else placeholder="请输入优惠金额"/>-->
                        </template>
                        <template slot="sellerPercentTitle">
                            优惠类型
                            <a-popover content="请选择优惠类型">
                                <a-icon type="question-circle"/>
                            </a-popover>
                        </template>
                        <template slot="teamPercentTitle">
                            设置优惠折扣或优惠金额
                            <a-popover content="请设置优惠折扣或优惠金额">
                                <a-icon type="question-circle"/>
                            </a-popover>
                        </template>
                    </a-table>

                    <a-table
                            v-show="formData.open_member_discount==1&&formData.member_discount_goods_mode==2 && skuTable.sku_list.length"
                            :columns="skuColumns" :dataSource="skuTable.sku_list" :pagination="false" rowKey="key"
                            bordered>
                        <template slot="memberDiscount">
                            <a-popconfirm okText="确定" cancelText="取消" @confirm="setAllMemberDiscount">
                                <span slot="icon"/>
                                <template slot="title">
                                    <PriceInput
                                            :formData="setAll"
                                            field="setAllMemberDiscountValue"
                                            placeholder="批量设置会员价格"/>
                                </template>
                                会员价格
                                <a-icon type="form"/>
                            </a-popconfirm>
                        </template>


                        <template slot="id" slot-scope="text,record,index">
                            <a-input v-model="record.id" placeholder="id"/>
                        </template>
                        <template slot="member_price" slot-scope="text,record,index">
                            <PriceInput v-show="formData.member_discount_mode==1"
                                        :formData="record"
                                        field="member_price"
                                        placeholder="会员价格(元)"/>

                            <PriceInput v-show="formData.member_discount_mode==2"
                                        :formData="record.member_discount_rule"
                                        :field="sellerGroupSelectValue"
                                        placeholder="会员价格(元)"/>
                            <!--<a-input v-show="formData.seller_reward_mode==1" v-model="record.seller_reward" placeholder="提成(元)"/>-->
                            <!--<a-input v-show="formData.seller_reward_mode==2" v-model="record.seller_reward_rule[sellerGroupSelectValue]" placeholder="提成(元)"/>-->
                        </template>

                    </a-table>
                </div>
            </a-form>

        </a-spin>
        <template slot="footer">
            <a-button key="cancel" @click="handleCancel">取消</a-button>
            <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
        </template>
    </a-modal>
</template>

<script>
    import RSwitch from '@/components/RSwitch/'
    import {getMemberDiscountSetting, memberDiscountSetting} from '@/api/goods'
    import PriceInput from '@/components/PriceInput/'

    export default {
        name: 'GoodsMemberDiscountForm',
        components: {
            RSwitch,
            PriceInput,
        },
        props: {
            goodsId: {
                type: String | Number,
                required: true
            },
            visible: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                labelCol: {
                    xs: {span: 24},
                    sm: {span: 5},
                },
                wrapperCol: {
                    xs: {span: 24},
                    sm: {span: 12},
                },
                form: this.$form.createForm(this),
                goods: {
                    id: this.$route.query.id
                },
                saveLoading: false,
                setAll: {
                    setAllSellerRewardValue: '',
                    setAllTeamRewardValue: '',
                    setAllMemberDiscountValue: '',
                },
                formData: {
                    goods_id: 0,
                    open_member_discount: 1,
                    seller_reward_setting_mode: 1,
                    seller_reward_mode: 1,
                    member_discount_goods_mode: 1,
                    memberDiscountList: [],
                    sku: [],
                    sku_list: []
                },
                sellerGroupSelectValue: undefined,
                sku_fields_list: [],
                setAllPriceValue: '',
                skuTable: {
                    sku_fields_sets: [],
                    sku_list: [],
                },
                //表头
                sellerGroupColumns: [
                    {
                        title: '会员卡类型',
                        width: '100px',
                        dataIndex: 'name',
                    },
                    {
                        width: '100px',
                        dataIndex: 'seller_percent',
                        slots: {title: 'sellerPercentTitle'},
                        scopedSlots: {customRender: 'sellerPercent'},
                    },
                    {
                        width: '100px',
                        dataIndex: 'team_percent',
                        slots: {title: 'teamPercentTitle'},
                        scopedSlots: {customRender: 'teamPercent'},
                    },
                ],
            }
        },
        watch: {
            goodsId(value) {
                let that = this
                console.log("goodsId", value)
                if (value) {
                    that.getMemberDiscountSetting();
                }
            }
        },
        methods: {
            priceChange(data) {
                console.log(data)
            },
            sellerRewardChange(data, item) {
                console.log(data, item)
                console.log(this.skuTable.sku_list)

            },
            setAllMemberDiscount() {
                let that = this;
                that.skuTable.sku_list.map(item => {
                    if (that.formData.member_discount_mode == 1) {
                        // console.log(item.seller_reward)
                        item.member_discount = that.setAll.setAllMemberDiscountValue;
                    } else {
                        item.member_discount_rule[that.sellerGroupSelectValue] = that.setAll.setAllMemberDiscountValue;
                        console.log(item, that.sellerGroupSelectValue)
                    }
                });
            },
            handleOk(e) {
                let self = this
                e.preventDefault()
                this.form.validateFields((err, values) => {
                    if (!err) {
//            self.saveLoading = true;
                        console.log('Received values of form: ', values)
                        console.log('Received valuess of formData: ', self.formData)
                        self.formData.goods_id = self.goodsId;
                        self.formData.sku_list = JSON.stringify(self.skuTable.sku_list)
                        // self.formData.sku_list = self.skuTable.sku_list

                        memberDiscountSetting(Object.assign(self.formData, values)).then(res => {
                            self.$message.success('设置成功')
                            self.saveLoading = false;
                            this.$emit('sellerRewardDone')
                        }).catch(err => {
                            self.$message.error(err.data.msg);
                            self.saveLoading = false;
                        })
                    } else {
                        console.log(err);
                    }
                })
            },
            handleCancel() {
                this.$emit('sellerRewardDone')
            },
            getMemberDiscountSetting() {
                let that = this
                getMemberDiscountSetting({goods_id: that.goodsId}).then(res => {
                    that.formData = res.data;
                    that.form.setFieldsValue({...res.data});
                    that.formData.sku = res.data.sku;
                    that.sku_fields_list = res.data.sku_fields_list;
                    if (that.formData.memberDiscountList.length > 0) {
                        that.sellerGroupSelectValue = that.formData.memberDiscountList[0].id;

                        console.log(that.sellerGroupSelectValue)
                    }
                    that.refreshSkuList();
                })
                // .catch(err =>{
                //   that.$message.error(err.data.msg)
                // })
            },

            refreshSkuList() {
                let self = this;
                var sets = [];
                var skulist = [];
                var count = [];
                if (this.sku_fields_list.length == 0 || this.sku_fields_list[0].attrs.length == 0) {
                    return {
                        'sku_fields_sets': sets,
                        'sku_list': skulist,
                    }
                }
                for (var i = this.sku_fields_list.length - 1; i >= 0; i--) {
                    var key = this.sku_fields_list.length - 1 - i;
                    var rkey = i;
                    var list = [];
                    var len = this.sku_fields_list[i].attrs.length;
                    if (i - 1 >= 0) {
                        count[i - 1] = len * (count[i] ? count[i] : 1);
                    }

                    sets[key] = [];
                    if (key == 0) {
                        for (var l = 0; l < this.sku_fields_list[key].attrs.length; l++) {
                            sets[key].push({
                                'id': this.sku_fields_list[key].attrs[l].id,
                                'title': this.sku_fields_list[key].attrs[l].title,
                                'sku': [{
                                    'field_id': this.sku_fields_list[key].id,
                                    'attr_id': this.sku_fields_list[key].attrs[l].id,
                                    'attr_title': this.sku_fields_list[key].attrs[l].title,
                                }]
                            })
                        }
                    } else {
                        var ccount = sets[key - 1].length;
//                        console.log('ccount');
//                        console.log(ccount);
                        for (var n = 0; n < ccount; n++) {
                            for (var j = 0; j < this.sku_fields_list[key].attrs.length; j++) {
                                var sku = sets[key - 1][n]['sku'];
                                sets[key].push(
                                    {
                                        'id': this.sku_fields_list[key].attrs[j].id,
                                        'title': this.sku_fields_list[key].attrs[j].title,
                                        'sku': sku.concat({
                                            'field_id': this.sku_fields_list[key].id,
                                            'attr_id': this.sku_fields_list[key].attrs[j].id,
                                            'attr_title': this.sku_fields_list[key].attrs[j].title,
                                        })
                                    }
                                )
                            }
//                            sets[key] = sets[key].concat(this.sku_fields_list[key].attrs);
                        }
//                        console.log('set');
//                        console.log(sets[key]);
                    }
                }

                for (var k = 0; k < sets.length; k++) {
                    for (var index = 0; index < sets[k].length; index++) {
                        sets[k][index].height = count[k] ? count[k] : 1;
                    }
                }
                if (sets[sets.length - 1].length == 0) {
                    sets.splice(sets.length - 1, 1);
                }

                // let seller_reward_rule_Arr = []
                // let team_reward_rule_Arr = []
                let member_discount_rule_Arr = []

                for (var p = 0; p < this.formData.sku.length; p++) {
                    // let seller_reward_rule = {}
                    // let team_reward_rule = {}

                    let member_discount_rule = {}
                    this.formData.memberDiscountList.map((item, index) => {
                        // console.log(index,this.formData.sku[p].seller_reward_rule,this.formData.sku[p].seller_reward_rule[item.id])
                        // seller_reward_rule[item.id] = this.formData.sku[p].seller_reward_rule[item.id]
                        // team_reward_rule[item.id] = this.formData.sku[p].team_reward_rule[item.id]
                        member_discount_rule[item.id] = this.formData.sku[p].member_discount_rule[item.id]
                    })
                    // seller_reward_rule_Arr.push(seller_reward_rule)
                    // team_reward_rule_Arr.push(team_reward_rule)
                    member_discount_rule_Arr.push(member_discount_rule)
                }
                console.log(member_discount_rule_Arr)
                for (var m = 0; m < sets[sets.length - 1].length; m++) {
                    var row = {
                        'key': 'm' + m,
                        'id': 0,
                        'code': '',
                        'price': 0,
                        // 'seller_reward_rule': seller_reward_rule_Arr[m],
                        // 'team_reward_rule': team_reward_rule_Arr[m],
                        'member_discount_rule': member_discount_rule_Arr[m],
                        'seller_reward': 0,
                        'team_reward': 0,
                        'cost_price': 0,
                        'sold_count': 0,
                        'unit_count': 1,
                        'stock': 0,
                        'popoverVisible': false,
                        'sku': sets[sets.length - 1][m].sku,
                        'height': sets[sets.length - 1][m].height
                    };
                    for (var p = 0; p < this.formData.sku.length; p++) {
                        let skuArray = [];
                        sets[sets.length - 1][m].sku.map(skuItem => {
                            skuArray.push({
                                field_id: skuItem.field_id,
                                attr_id: skuItem.attr_id,
                            })
                        });
                        console.log('skuArray');
                        console.log(skuArray);
                        if (JSON.stringify(this.formData.sku[p].sku).replace(/"/g, '') == JSON.stringify(skuArray).replace(/"/g, '')) {
                            // let seller_reward_rule = []
                            // let team_reward_rule = []
                            let member_discount_rule = []
                            // if (this.formData.sku[p].seller_reward_rule.length > 0) {
                            //     seller_reward_rule = this.formData.sku[p].seller_reward_rule
                            // } else {
                            //     seller_reward_rule = row.seller_reward_rule
                            // }
                            // if (this.formData.sku[p].team_reward_rule.length > 0) {
                            //     team_reward_rule = this.formData.sku[p].team_reward_rule
                            // } else {
                            //     team_reward_rule = row.team_reward_rule
                            // }
                            if (this.formData.sku[p].member_discount_rule.length > 0) {
                                member_discount_rule = this.formData.sku[p].member_discount_rule
                            } else {
                                member_discount_rule = row.member_discount_rule
                            }
                            row = {
                                'key': 'p' + p,
                                'id': this.formData.sku[p].id,
                                'code': this.formData.sku[p].code,
                                'price': this.formData.sku[p].price,
                                'cost_price': this.formData.sku[p].cost_price,
                                'sold_count': this.formData.sku[p].sold_count,
                                'unit_count': this.formData.sku[p].unit_count,
                                // 'seller_reward_rule': seller_reward_rule,
                                // 'team_reward_rule': team_reward_rule,
                                'member_discount_rule': member_discount_rule,
                                // 'seller_reward': this.formData.sku[p].seller_reward,
                                // 'team_reward': this.formData.sku[p].team_reward,
                                'member_price': this.formData.sku[p].member_price,
                                'stock': this.formData.sku[p].stock,
                                'popoverVisible': false,
                                'sku': sets[sets.length - 1][m].sku,
                                'height': sets[sets.length - 1][m].height
                            };

                            console.log(this.formData.sku)
                            break;
                        }
                    }
                    skulist.push(row);
                }
                console.log('skulist')
                console.log(skulist)
                self.skuTable = {
                    sku_fields_sets: sets,
                    sku_list: skulist,
                }
            },
        },
        computed: {
            visibleModel: {
                get: function () {
                    return this.visible;
                },
                set: function () {
                }
            },
            skuColumns() {
                let self = this;
                let skuColums = [];
                self.sku_fields_list.map((item, index) => {
                    if (item.attrs.length == 0) {
                        return;
                    }
                    skuColums.push({
                        title: '' + item.title,
                        width: 100,
                        dataIndex: 'sku[' + index + '].attr_title',
                        customRender: (value, row, index2) => {
                            const obj = {
                                children: value,
                                attrs: {},
                            };
                            let rowSpan = self.skuTable.sku_fields_sets[index][0].height;
                            if (index2 % rowSpan == 0) {
                                obj.attrs.rowSpan = rowSpan;
                            } else {
                                obj.attrs.rowSpan = 0;
                            }
                            return obj;
                        }
                    });
                });
                let constColums = [
                    {
                        width: 100,
                        dataIndex: 'price',
                        title: '原价',
                        customRender: (text) => {
                            return parseFloat(text).toFixed(2);
                        }
                    },
                    {
                        width: 100,
                        dataIndex: 'member_price',
                        slots: {title: 'memberDiscount'},
                        scopedSlots: {customRender: 'member_price'}
                    },
                    // {
                    //     width: 100,
                    //     dataIndex: 'seller_reward',
                    //     slots: {title: 'sellerReward'},
                    //     scopedSlots: {customRender: 'seller_reward'}
                    // },
                    // {
                    //     width: 100,
                    //     dataIndex: 'team_reward',
                    //     slots: {title: 'teamReward'},
                    //     scopedSlots: {customRender: 'team_reward'}
                    // },
                    {
                        width: 100,
                        title: '成本',
                        dataIndex: 'cost_price',
                        customRender: (text) => {
                            return parseFloat(text).toFixed(2);
                        }
                    },
                ];
                return skuColums.concat(constColums);
            }
        },
    }
</script>

<style lang="less" scoped>
</style>